import { useSelector } from 'react-redux';
import { selectDiscountCode } from '@store/order/selectors';



const Discount = (): JSX.Element => {

	const discountCode = useSelector(selectDiscountCode);

	if (!discountCode || discountCode.length === 0) return (
		<></>	
	)

	return (
		<div className='order-summary-element discount-element'>

			<h2>Slevový kód</h2>

			<div className='summary-property'>
				<p>{discountCode}</p>
			</div>

		</div>
	);
};

export default Discount;